import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { getDoc, doc, updateDoc } from 'firebase/firestore';
import { db } from '../App';
import { FaTrash } from 'react-icons/fa';

Modal.setAppElement('#root');

const UserInventory = ({ isOpen, onRequestClose, selectedUser }) => {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [stocks, setStocks] = useState([]);

  const fetchUserData = async (userId) => {
    if (!userId) {
      setInventoryItems([]);
      setStocks([]);
      return;
    }

    try {
      const userDocRef = doc(db, 'users', userId);
      const userDocSnap = await getDoc(userDocRef);
      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();

        const itemsData = await Promise.all(
          (userData.inventory || []).map(async (itemId) => {
            try {
              const originalItemId = itemId.split('_').slice(-1)[0];
              const itemDocRef = doc(db, 'items', originalItemId);
              const itemDocSnap = await getDoc(itemDocRef);

              if (itemDocSnap.exists()) {
                return {
                  id: itemId,
                  ...itemDocSnap.data()
                };
              } else {
                console.error(`Item with id ${originalItemId} does not exist`);
                return null;
              }
            } catch (error) {
              console.error(`Error fetching item ${itemId}:`, error);
              return null;
            }
          })
        );

        const validItemsData = itemsData.filter(item => item !== null);
        setInventoryItems(validItemsData);
        setStocks(userData.stocks || []);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    if (selectedUser) {
      fetchUserData(selectedUser.id);
    }
  }, [selectedUser]);

  const getItemNameWithoutPrefix = (itemName) => {
    return itemName.split('_').slice(1).join('_');
  };

  const handleDeleteItem = async (itemId) => {
    try {
      const updatedInventory = selectedUser.inventory.filter(item => item !== itemId);
      const userDocRef = doc(db, 'users', selectedUser.id);
      await updateDoc(userDocRef, {
        inventory: updatedInventory
      });

      setTimeout(async () => {
        await fetchUserData(selectedUser.id);
      }, 500);

    } catch (error) {
      console.error('Error deleting item from inventory:', error);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="User Inventory"
      className="userinventory-modal"
      overlayClassName="userinventory-modal-overlay"
    >
      <div className="userinventory-modal-content">
        <h2>{selectedUser?.name}'s Inventory</h2>
        <button onClick={onRequestClose} className="userinventory-close-modal-button">Close</button>
        <div className="userinventory-list">
          {inventoryItems.length > 0 ? (
            inventoryItems.map((item, index) => (
              <div key={index} className="userinventory-item">
                <img src={item.imageUrl} alt={getItemNameWithoutPrefix(item.name)} className="userinventory-item-image" />
                <p className="userinventory-item-name">{getItemNameWithoutPrefix(item.name)}</p>
                <div className="userinventory-delete-item-container">
                  <FaTrash 
                    className="userinventory-delete-item-icon" 
                    onClick={() => handleDeleteItem(item.id)}
                  />
                </div>
              </div>
            ))
          ) : (
            <p>No items in inventory</p>
          )}
        </div>
        <h2>{selectedUser?.name}'s Stocks</h2>
        <div className="userinventory-list">
          {stocks.length > 0 ? (
            stocks.map((stock, index) => (
              <div key={index} className="userinventory-item">
                <p className="userinventory-item-name">{stock.symbol}: {stock.amount}</p>
              </div>
            ))
          ) : (
            <p>No stocks in portfolio</p>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default UserInventory;
